export default __webpack_public_path__ + "static/media/main3(3).9ceef50a.png";